var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useApi from '@/hoc/hooks/useApi';
import { UpArrow } from '@/icons';
import { RightArrow } from '@/icons/right-arrow';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Modal from '../generic-customization-modal';
import { FormField } from '../ui';
var CustomNewEditModal = function (_a) {
    var _b, _c, _d, _e;
    var isOpen = _a.isOpen, mode = _a.mode, selectedItem = _a.selectedItem, onClose = _a.onClose, onSave = _a.onSave;
    var _f = useForm({
        defaultValues: {
            name: '',
            description: '',
            selectedStages: [],
            hire_state: '',
        },
        mode: 'onChange', // Validate on every change
    }), register = _f.register, handleSubmit = _f.handleSubmit, setValue = _f.setValue, reset = _f.reset, errors = _f.formState.errors, setError = _f.setError, clearErrors = _f.clearErrors, getValues = _f.getValues, watch = _f.watch;
    var _g = useState([]), stagesList = _g[0], setStagesList = _g[1];
    var _h = useState({}), expandedStages = _h[0], setExpandedStages = _h[1];
    var _j = useApi('/stage'), fetchData = _j.fetchData, data = _j.data, loading = _j.loading;
    useEffect(function () {
        fetchData();
    }, [fetchData]);
    var watchSelectedStages = watch('selectedStages');
    // Flatten all stages (parents + children) for the hire_state dropdown
    var allFlatStages = stagesList.flatMap(function (stage) { return __spreadArray([stage], (stage.children || []), true); });
    var selectedStagesForDropdown = allFlatStages.filter(function (stage) {
        return watchSelectedStages === null || watchSelectedStages === void 0 ? void 0 : watchSelectedStages.includes(stage._id);
    });
    // Clear hire_state if the selected stage is unchecked
    useEffect(function () {
        var currentHireState = getValues('hire_state');
        if (currentHireState && !(watchSelectedStages === null || watchSelectedStages === void 0 ? void 0 : watchSelectedStages.includes(currentHireState))) {
            setValue('hire_state', '');
        }
    }, [watchSelectedStages, getValues, setValue]);
    useEffect(function () {
        var _a;
        var selectedStages = (_a = ((stagesList === null || stagesList === void 0 ? void 0 : stagesList.filter(function (stage) { return stage.isDefault; })) || [])) === null || _a === void 0 ? void 0 : _a.map(function (stage) { return stage._id; });
        setValue('selectedStages', selectedStages, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
        });
    }, [stagesList]);
    useEffect(function () {
        if (data) {
            setStagesList(data);
            // Expand all stages by default
            var defaultExpanded_1 = {};
            data.forEach(function (stage) {
                defaultExpanded_1[stage._id] = true; // Expand parent stages
            });
            setExpandedStages(defaultExpanded_1);
        }
        else {
            fetchData().catch(function (error) { return console.error('Error fetching stage data: ', error); });
        }
    }, [data]);
    useEffect(function () {
        var _a;
        if (isOpen) {
            if (mode === 'edit' && selectedItem) {
                reset({
                    name: selectedItem.name,
                    description: selectedItem.description,
                    selectedStages: selectedItem.stageId || [],
                    hire_state: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.hire_state) || '',
                });
            }
            else if (mode === 'create') {
                // Create mode: set default selected stages from isDefault
                var defaultSelectedStages = (_a = ((stagesList === null || stagesList === void 0 ? void 0 : stagesList.filter(function (stage) { return stage.isDefault; })) || [])) === null || _a === void 0 ? void 0 : _a.map(function (stage) { return stage._id; });
                reset({
                    name: '',
                    description: '',
                    selectedStages: defaultSelectedStages,
                    hire_state: '',
                });
            }
        }
        else {
            // If modal is closed, reset form to initial state
            reset();
        }
    }, [isOpen, mode, selectedItem, stagesList, reset]);
    var toggleExpand = function (stageId) {
        setExpandedStages(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[stageId] = !prev[stageId], _a)));
        });
    };
    var handleStageSelection = function (stageId, children) {
        var selectedStages = new Set(getValues('selectedStages') || []);
        if (selectedStages.has(stageId)) {
            // If already selected, remove it and all its children
            selectedStages.delete(stageId);
            children === null || children === void 0 ? void 0 : children.forEach(function (child) { return selectedStages.delete(child._id); });
        }
        else {
            // Select the stage
            selectedStages.add(stageId);
            if (children && children.length > 0) {
                children.forEach(function (child) { return selectedStages.add(child._id); });
            }
        }
        // Parent-Child Selection/Deselection Logic
        stagesList.forEach(function (stage) {
            var _a, _b;
            if ((_a = stage.children) === null || _a === void 0 ? void 0 : _a.some(function (child) { return selectedStages.has(child._id); })) {
                selectedStages.add(stage._id); // Select parent if any child is selected
            }
            else if ((_b = stage.children) === null || _b === void 0 ? void 0 : _b.every(function (child) { return !selectedStages.has(child._id); })) {
                selectedStages.delete(stage._id); // Deselect parent if all children are unselected
            }
        });
        setValue('selectedStages', Array.from(selectedStages));
        // Validate stages after selection
        var currentStages = Array.from(selectedStages);
        if (currentStages.length === 0) {
            setError('selectedStages', {
                type: 'required',
                message: 'At least one stage must be selected',
            });
        }
        else {
            clearErrors('selectedStages');
        }
    };
    var validateName = function (value) {
        if (!value)
            return 'Name is required';
        if (value.length < 3)
            return 'Name must be at least 3 characters';
        if (value.length > 20)
            return 'Name cannot exceed 20 characters';
        return true;
    };
    var validateDescription = function (value) {
        if (value && value.length > 0) {
            if (value.length < 3)
                return 'Description must be at least 3 characters';
            if (value.length > 1000)
                return 'Description cannot exceed 1000 characters';
        }
        return true;
    };
    var onSubmit = function (formData) {
        // Validate name
        var nameValidation = validateName(formData.name);
        if (nameValidation !== true) {
            setError('name', { type: 'validate', message: nameValidation });
            return;
        }
        // Validate description
        var descValidation = validateDescription(formData.description);
        if (descValidation !== true) {
            setError('description', { type: 'validate', message: descValidation });
            return;
        }
        // Validate stages
        if (!formData.selectedStages || formData.selectedStages.length === 0) {
            setError('selectedStages', {
                type: 'required',
                message: 'At least one stage must be selected',
            });
            return;
        }
        // Validate hire_state
        if (!formData.hire_state) {
            setError('hire_state', {
                type: 'required',
                message: 'Final Hire Status is required',
            });
            return;
        }
        var newItem = [
            {
                name: formData.name,
                description: formData.description,
                stageId: formData.selectedStages,
                hire_state: formData.hire_state || undefined,
            },
        ];
        if (mode === 'edit') {
            newItem[0]._id = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem._id;
        }
        onSave(newItem);
    };
    return (_jsx(Modal, { title: mode === 'create' ? 'New Customization' : 'Edit Customization', isOpen: isOpen, onClose: onClose, size: 'full', cancelButton: { label: 'Cancel', onClick: onClose }, actionButton: {
            label: mode === 'create' ? 'Create' : 'Update',
            onClick: handleSubmit(onSubmit),
            variant: 'primary',
        }, children: _jsxs("div", { className: 'flex  gap-4 mb-4 flex-row', children: [_jsxs("div", { className: 'w-full flex flex-col gap-2 md:w-1/2', children: [_jsx(FormField, { error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message, label: 'Name', isRequired: true, tooltip: 'Process Name', containerClassName: 'w-full', children: _jsx("input", __assign({}, register('name', { validate: validateName }), { type: 'text', className: 'w-full border border-vjwSecondary p-2 rounded-lg bg-blue-50', placeholder: 'Name the customized stage' })) }), _jsx(FormField, { error: (_c = errors.description) === null || _c === void 0 ? void 0 : _c.message, label: 'Description (Optional)', tooltip: 'Process Name', containerClassName: 'w-full', children: _jsx("textarea", __assign({}, register('description', { validate: validateDescription }), { className: 'w-full border border-vjwSecondary p-2 rounded-lg bg-blue-50 h-48', placeholder: 'Enter the description' })) }), _jsx(FormField, { label: 'Final Hire Status', isRequired: true, tooltip: 'Defines which status indicates the candidate has been successfully hired.', error: (_d = errors.hire_state) === null || _d === void 0 ? void 0 : _d.message, containerClassName: 'w-full', children: _jsxs("select", __assign({}, register('hire_state', { required: 'Final Hire Status is required' }), { className: 'w-full border border-vjwSecondary p-2 rounded-lg bg-blue-50', children: [_jsx("option", { value: '', children: "Select Final Hire Status" }), selectedStagesForDropdown.map(function (stage) { return (_jsx("option", { value: stage._id, children: stage.name }, stage._id)); })] })) })] }), _jsx("div", { className: 'w-full md:w-1/2', children: _jsx(FormField, { error: (_e = errors.selectedStages) === null || _e === void 0 ? void 0 : _e.message, label: 'Select the stages', isRequired: true, containerClassName: 'w-full', children: _jsx("div", { className: 'max-h-50 w-full border border-vjwSecondary rounded-lg p-2 bg-blue-50', children: stagesList.map(function (stage, parentIndex) { return (_jsxs("div", { className: 'mb-2', children: [_jsxs("div", { className: 'flex items-center', children: [_jsx("input", { type: 'checkbox', checked: watchSelectedStages === null || watchSelectedStages === void 0 ? void 0 : watchSelectedStages.includes(stage._id), onChange: function () { return handleStageSelection(stage._id, stage.children); }, className: 'mr-2', disabled: stage.isDefault }), _jsxs("span", { className: 'text-sm', children: [parentIndex + 1, ". ", stage.name] }), stage.children && stage.children.length > 0 && (_jsx("button", { type: 'button', onClick: function () { return toggleExpand(stage._id); }, className: 'ml-2 text-xs text-blue-500', children: expandedStages[stage._id] ? _jsx(UpArrow, {}) : _jsx(RightArrow, {}) }))] }), expandedStages[stage._id] && stage.children && (_jsx("div", { className: 'ml-5 pl-3 border-l-2 border-vjwSecondary', children: stage.children.map(function (subStage, subIndex) { return (_jsxs("div", { className: 'flex items-center mt-1', children: [_jsx("input", { type: 'checkbox', checked: watchSelectedStages === null || watchSelectedStages === void 0 ? void 0 : watchSelectedStages.includes(subStage._id), onChange: function () { return handleStageSelection(subStage._id); }, className: 'mr-2' }), _jsxs("span", { className: 'text-sm', children: [parentIndex + 1, ".", subIndex + 1, " ", subStage.name] })] }, subStage._id)); }) }))] }, stage._id)); }) }) }) })] }) }));
};
export default CustomNewEditModal;
